import React, { useState, createContext } from "react";
import { IAuth, IConfiguration } from "../../interfaces/interface";

export const AppContext = createContext<any>({});

export const AppProvider: React.FC = (props) => {
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState<boolean>(true);
  const [disableLinks, setDisableLinks] = useState<string[]>([])
  const [configuration, setConfiguration] = useState<IConfiguration>({
    enableLoadSensor: true,
    enableHomeLocation: false,
    assetTypes: [],
    locationTypes: [],
    profiles: undefined,
    states: undefined,

  })
  const [auth, setAuth] = useState<IAuth>({
    token: "",
    expiresOn: "",
    scope: "",
    header:{
      headers: {
        Authorization: ``
      }
    },
    username:"",
  })
  const [displayMessage, setDisplayMessage] = useState<string>("none")

  const navBarClickHandler = (e: any): void => {   
    if(e.target.className.endsWith("close-nav-bar-icon") && displayMessage === "none") {
        setIsNavbarOpen(true);
    }else if(isNavbarOpen && 
      (e.target.className.startsWith("page"))){
        setIsNavbarOpen(false);
    }
  }
  const errorHandler = (status:number):string => {
    switch(status){
      case 401:
        return "Invalid username or password";
      case 408:
        return "Hoopo Server is temporarily not available. Please try again later";
      case 440:
        return "Hoopo DB Server is temporarily not available. Please try again later";
      case 441:
        return "Hoopo Server is temporarily not available. Please try again later";
      case 442:
        return "Hoopo Server is temporarily not available(0x2). Please try again later";
      case 443:
        return "Hoopo Server is temporarily not available(0x3). Please try again later";
      case 500: 
        return "Hoopo Web Server is temporarily not available. Please try again later"; 
      default:
        return "Hoopo Server is temporarily not available(0x10). Please try again later";
    }
  }
  const [assetNamesToDisplay, setAssetNamesToDisplay] = useState({
    assetName: "Asset Name",
    deviceId: "Tracker Id",
    loadSensorId: "Load Sensor ID",
    assetType: "Asset Type",
    assetDescription: "Description",
    oldDeviceId: "Old Tracker ID",
    newDeviceId: "New Tracker ID",
    oldDeviceIdStatus: "Old Tracker ID New Status",
    profile: "Profile",
    state: "State",
    sensorId: "Sensor ID",
    firmwareVersion: "Firmware Version"
})


  return (
    <AppContext.Provider
      value={{
        login: [isLogged, setIsLogged],
        navBarStatus : [isNavbarOpen, setIsNavbarOpen],
        config: [configuration, setConfiguration],
        authorization: [auth, setAuth],
        disMessage: [displayMessage, setDisplayMessage],
        linksDisable: [disableLinks, setDisableLinks],
        navBarHandler: navBarClickHandler,
        assetNamesArr: [assetNamesToDisplay, setAssetNamesToDisplay],
        errorHandlerFunction: errorHandler,
      }}
      >
      {props.children}
    </AppContext.Provider>
  );
};
